import { ClerkProvider } from '@clerk/react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LandingPage } from '@/components/features/LandingPage';
import { SignInPage } from '@/app/(auth)/sign-in/page';
import { SignUpPage } from '@/app/(auth)/sign-up/page';
import { ChatPage } from '@/app/chat/page';
import { DocumentsPage } from '@/app/documents/page';
import { PricingPage } from '@/app/pricing/page';
import { DashboardPage } from '@/app/dashboard/page';
import { DisclaimerPage } from '@/app/disclaimer/page';
import { DemoAuthProvider } from '@/lib/demo-auth';

function App() {
  return (
    <DemoAuthProvider>
      <ClerkProvider
        publishableKey={import.meta.env.VITE_CLERK_PUBLISHABLE_KEY}
        appearance={{
          baseTheme: undefined,
          variables: {
            colorPrimary: '#0ea5e9',
            colorBackground: '#ffffff',
            colorText: '#18181b',
            colorInput: '#ffffff',
            colorInputBackground: '#f4f4f5',
            colorDanger: '#ef4444',
            colorSuccess: '#22c55e',
            colorWarning: '#f59e0b',
            fontFamily: 'Inter, system-ui, sans-serif',
            borderRadius: '24px',
          },
          elements: {
            formButtonPrimary: 'bg-primary-600 hover:bg-primary-700 text-sm font-semibold px-6 py-3 rounded-button transition-all duration-200',
            card: 'rounded-card shadow-soft',
            headerTitle: 'font-semibold text-surface-900',
            headerSubtitle: 'text-surface-500',
            socialButtonsBlockButton: 'rounded-button',
            formFieldInput: 'rounded-input border-2 border-surface-200 focus:border-primary-500 focus:ring-4 focus:ring-primary-100',
            footerActionLink: 'text-primary-600 hover:text-primary-700',
            identityPreviewText: 'font-medium',
            identityPreviewEditButton: 'text-primary-600',
          },
        }}
      >
        <BrowserRouter>
          <div className="min-h-screen bg-surface-50">
            {/* Global Disclaimer Banner */}
            <div className="bg-warning-50 border-b border-warning-200 px-4 py-2 text-center">
              <p className="text-sm text-warning-800">
                <strong>Disclaimer:</strong> This is <span className="italic">not legal advice</span>. We are not lawyers. Please consult a real lawyer for actual legal matters.
              </p>
            </div>
            <main>
              <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/sign-in/*" element={<SignInPage />} />
                <Route path="/sign-up/*" element={<SignUpPage />} />
                <Route path="/chat" element={<ChatPage />} />
                <Route path="/documents" element={<DocumentsPage />} />
                <Route path="/pricing" element={<PricingPage />} />
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/disclaimer" element={<DisclaimerPage />} />
              </Routes>
            </main>
          </div>
        </BrowserRouter>
      </ClerkProvider>
    </DemoAuthProvider>
  );
}

export default App;
